import { UPDATE_PRODUCT } from "../../types/ProductType";

import axios from "axios";
import { toast } from "react-toastify";

const updateProductAction = (data) => {
  return {
    type: UPDATE_PRODUCT,
    payload: data,
  };
};

export const updateProduct = (id, values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        url: `product/${id}`,
        data: values,
      });
      //dispatching data
      dispatch(updateProductAction(data));
      toast.success("Product Updated Successfully");
      return {
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error(error.response?.data?.message || "Error updating product");
      return {
        message: "error",
      };
    }
  };
};
